<template>
  <div id="app">

    <!-- COOKIE BANNER -->
    <CookieBannerComponent
      @accepted="activarAnalytica"
      @rejected="rechazarAnalytica"
    />

    <!-- HEADER -->
    <header>
      <NavBarComponent />
    </header>

    <!-- MAIN -->
    <main>
      <router-view />
    </main>

    <!-- FOOTER -->
    <footer class="footer">

      <!-- LEFT -->
      <div>

        <div>
          <p>&copy; {{ currentYear }} Raptoris.</p>
          <p>Email: info@raptoris.com</p>
        </div>

        <!-- SOCIALS -->
        <div class="social-icons">

          <!-- INSTAGRAM -->
          <a
            href="https://www.instagram.com/raptorisstore/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#000000"
              stroke-width="1"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M4 4m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z" />
              <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
              <path d="M16.5 7.5l0 .01" />
            </svg>
          </a>

          <!-- FACEBOOK -->
          <a
            href="https://www.facebook.com/profile.php?id=61577349881673"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#000000"
              stroke-width="1"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3" />
            </svg>
          </a>

        </div>

        <h4>¡Síguenos!</h4>

      </div>

      <!-- FOOTER LINKS -->
      <div class="footer-links">

        <router-link to="/nosotros">
          Sobre Nosotros
        </router-link>

        <router-link to="/FAQs">
          Preguntas Frecuentes
        </router-link>

        <router-link to="/contacto">
          Contacto
        </router-link>

        <router-link to="/aviso-privacidad">
          Aviso de Privacidad
        </router-link>

      </div>

    </footer>

  </div>
</template>

<script>
import NavBarComponent from "@/views/NavBarComponent.vue";
import CookieBannerComponent from "@/components/CookieBannerComponent.vue";

export default {

  name: "App",

  components: {
    NavBarComponent,
    CookieBannerComponent
  },

  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  },

  methods: {
    activarAnalytica() {
      // Aquí activas Google Analytics u otro script cuando el usuario acepta
      // Ejemplo:
      // window.gtag('consent', 'update', { analytics_storage: 'granted' })
      console.log("Cookies aceptadas — analítica activada");
    },

    rechazarAnalytica() {
      // Aquí puedes asegurarte de que ningún script de seguimiento se ejecute
      console.log("Cookies rechazadas — analítica desactivada");
    }
  }
};
</script>

<style>

@import './assets/styles/main.css';
@import './assets/styles/normalize.css';

/* APP */
#app{
  min-height:100vh;
  display:flex;
  flex-direction:column;
}

main{
  flex:1;
}

/* FOOTER */
.footer{

  position:relative;

  padding:2.5rem 2rem 1.2rem;

  background:
    linear-gradient(
      135deg,
      #06120d 0%,
      #012719 55%,
      #023020 100%
    );

  color:white;

  display:grid;

  grid-template-columns:1fr auto;

  align-items:center;

  gap:2rem;

  border-top:
    1px solid rgba(255,255,255,.08);

  box-shadow:
    0 -8px 25px rgba(0,0,0,.12);

  overflow:hidden;
}

/* GLOW */
.footer::before{

  content:"";

  position:absolute;

  top:-120px;
  right:-100px;

  width:240px;
  height:240px;

  background:
    radial-gradient(
      circle,
      rgba(15,118,110,.12),
      transparent 70%
    );

  pointer-events:none;
}

/* LEFT */
.footer > div:first-child{

  display:flex;

  flex-direction:column;

  gap:.8rem;

  z-index:2;
}

.footer p{

  margin:0;

  font-size:.88rem;

  color:rgba(255,255,255,.75);

  line-height:1.6;

  letter-spacing:.3px;
}

/* FOLLOW */
.footer h4{

  margin:0;

  font-size:.8rem;

  font-weight:500;

  letter-spacing:2px;

  text-transform:uppercase;

  color:#d1fae5;
}

/* SOCIALS */
.social-icons{

  display:flex;

  gap:.8rem;
}

.social-icons a{

  width:42px;
  height:42px;

  display:flex;

  align-items:center;
  justify-content:center;

  border-radius:50%;

  background:rgba(255,255,255,.05);

  border:
    1px solid rgba(255,255,255,.08);

  backdrop-filter:blur(6px);

  transition:all .3s ease;
}

.social-icons a svg{

  width:20px;
  height:20px;

  stroke:white;

  transition:.3s;
}

.social-icons a:hover{

  transform:translateY(-3px);

  background:rgba(15,118,110,.25);

  box-shadow:
    0 8px 18px rgba(0,0,0,.2);
}

/* LINKS */
.footer-links{

  display:flex;

  gap:2rem;

  z-index:2;
}

.footer-links a{

  color:rgba(255,255,255,.78);

  text-decoration:none;

  font-size:.92rem;

  font-weight:400;

  letter-spacing:.3px;

  position:relative;

  transition:.3s;
}

.footer-links a::after{

  content:"";

  position:absolute;

  left:0;
  bottom:-5px;

  width:0;
  height:1px;

  background:#d1fae5;

  transition:.3s;
}

.footer-links a:hover{
  color:white;
}

.footer-links a:hover::after{
  width:100%;
}

/* SIGNATURE */
.footer::after{

  content:"Diseñado para crecer contigo";

  position:absolute;

  bottom:8px;
  left:50%;

  transform:translateX(-50%);

  font-size:.58rem;

  letter-spacing:2px;

  text-transform:uppercase;

  color:rgba(255,255,255,.22);
}

/* TABLET */
@media (max-width:900px){

  .footer{

    grid-template-columns:1fr;

    text-align:center;

    gap:1.5rem;
  }

  .footer > div:first-child{
    align-items:center;
  }

  .footer-links{

    justify-content:center;

    flex-wrap:wrap;

    gap:1.5rem;
  }
}

/* MOBILE */
@media (max-width:768px){

  .footer{
    padding:2rem 1rem 1rem;
  }

  .social-icons a{
    width:38px;
    height:38px;
  }

  .social-icons a svg{
    width:18px;
    height:18px;
  }

  .footer p{
    font-size:.8rem;
  }

  .footer-links a{
    font-size:.85rem;
  }

  .footer::after{
    font-size:.5rem;
  }
}

</style>